import type {
  IPlaybackScheduleRoot,
  IPlayerRegistrationPayload,
  IScheduleRootAssignment,
  ITenantInfo
} from '@lucimark/shared/models/player-registration-payload'
import type { TRegistrationStatusPlayerGroupDisplay } from '@/helpers/registrationPlayerGroupDisplay'
import type { IPlayerInfoPayload } from '@/types/registrationStatusPlayerInfo'
import Emittery from 'emittery'
import RegistrationStatusWorker from '@/workers/registrationStatus.worker?worker'

export type { IPlayerInfoPayload } from '@/types/registrationStatusPlayerInfo'

export enum RegistrationStatusServiceEvent {
  TENANT_UPDATE = 'tenant-update',
  PLAYER_GROUP_UPDATE = 'player-group-update',
  PLAYER_INFO_UPDATE = 'player-info-update',
  /** Full registration schedule root list (top-level `schedule` on the payload). */
  SCHEDULE_ROOTS_UPDATE = 'schedule-roots-update',
  CAMPAIGN_UPDATE = 'campaign-update',
  CAMPAIGN_PRELOAD = 'campaign-preload',
  NEXT_CAMPAIGN_SCHEDULED = 'next-campaign-scheduled'
}

export interface RegistrationStatusServiceEventMap {
  [RegistrationStatusServiceEvent.TENANT_UPDATE]: ITenantInfo | null
  [RegistrationStatusServiceEvent.PLAYER_GROUP_UPDATE]: TRegistrationStatusPlayerGroupDisplay | null
  [RegistrationStatusServiceEvent.PLAYER_INFO_UPDATE]: IPlayerInfoPayload | null
  [RegistrationStatusServiceEvent.SCHEDULE_ROOTS_UPDATE]: IScheduleRootAssignment[]
  [RegistrationStatusServiceEvent.CAMPAIGN_UPDATE]: IPlaybackScheduleRoot | null
  [RegistrationStatusServiceEvent.CAMPAIGN_PRELOAD]: IPlaybackScheduleRoot | null
  [RegistrationStatusServiceEvent.NEXT_CAMPAIGN_SCHEDULED]: IPlaybackScheduleRoot | null
}

const CMD_SET_REGISTRATION_STATUS = 'setRegistrationStatus'
const CMD_STOP = 'stop'

interface WorkerMessageOut {
  type: string
  payload: ITenantInfo | TRegistrationStatusPlayerGroupDisplay | IPlayerInfoPayload | IScheduleRootAssignment[] | IPlaybackScheduleRoot | null
}

export class RegistrationStatusService extends Emittery<RegistrationStatusServiceEventMap> {
  private _worker: Worker

  constructor() {
    super()
    this._worker = new RegistrationStatusWorker()
    this._worker.onmessage = (e: MessageEvent<WorkerMessageOut>) => {
      const { type, payload } = e.data
      void this.emit(type as RegistrationStatusServiceEvent, payload)
    }
  }

  setRegistrationStatus(payload: IPlayerRegistrationPayload | null): void {
    this._worker.postMessage({ type: CMD_SET_REGISTRATION_STATUS, payload })
  }

  stop(): void {
    this._worker.postMessage({ type: CMD_STOP })
    this._worker.terminate()
  }
}
